import { EDatePickerMode } from '../../../types'
import { IDatePickerModeLang } from '../../../types/lang'

export const datePickerModeLang: IDatePickerModeLang = {
	date_picker_mode: {
		[EDatePickerMode.today]: 'today_ru',
		[EDatePickerMode.yesterday]: 'yesterday_ru',
		[EDatePickerMode.currentWeek]: 'current week_ru',
		[EDatePickerMode.last7Days]: 'last 7 days_ru',
		[EDatePickerMode.currentMonth]: 'current month_ru',
		[EDatePickerMode.lastMonth]: 'last month_ru',
		[EDatePickerMode.last30Days]: 'last 30 days_ru',
		[EDatePickerMode.currentYear]: 'current year_ru',
		[EDatePickerMode.pastYear]: 'past year_ru'
	}
}